module.exports = __webpack_public_path__ + "static/media/p5.c91fcfa6.jpg";